<template>
  <DefaultLayout
    :pageProps="{
      title: `Join ${invitedBy} on Loop`,
      description:
        'You\'ve been invited to join Loop, click continue to finish your set-up.',
    }"
  >
    <template #content>
      <RegistrationCard :is-invite="true" />
    </template>
  </DefaultLayout>
</template>

<script>
import RegistrationCard from "../components/newDesign/RegistrationCard";
import mobileRedirect from "../mixins/helpers/mobileRedirect";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import OriginEnum from "@/helpers/enums/OriginEnum";
import { mapMutations } from "vuex";
export default {
  name: "index",
  components: { DefaultLayout, RegistrationCard },
  mixins: [mobileRedirect],
  data() {
    return {
      invitedBy: "Loop",
    };
  },
  async mounted() {
    if (this.$route.query.invited_by) {
      this.invitedBy = this.$route.query.invited_by;
    }
    this.setOrigin(OriginEnum.WEBAPP_PROD);
  },
  methods: {
    ...mapMutations("data", ["setOrigin"]),
  },
};
</script>
